import React, { Component } from 'react';
import './Home.scss';
import { addMessage } from "../../../store/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

const mapDispatchToProps = /* istanbul ignore next */ dispatch => {
    return {
        addMessage: message => dispatch(addMessage(message))
    };
};

export class ConnectedHome extends Component {

    render() {
        if (process.env.REACT_APP_SYSTEM_MESSAGE_HOME) {
            this.props.addMessage({
                type: "warning",
                message: <div dangerouslySetInnerHTML={{ __html: process.env.REACT_APP_SYSTEM_MESSAGE_HOME }} />,
                className: 'w-100',
                time: 10000000
            });
        }

        return (
            <>
                <div className="main">
                    <div className="col-12">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 bg">
                                    <h1 className="text-center">Hooldus-, heakorra- ja haljastustööde infosüsteem</h1>
                                    <hr />
                                    <p>
                                        Siin saate teha järgmisi hooldus-, heakorra- ja haljastustöödega seotud toiminguid:
                                    </p>
                                    <ul>
                                        <li>
                                            <a href="/add">teavitada probleemist</a>
                                        </li>
                                        <li>
                                            <a href="/map">otsida veebikaardilt objekte, nt Tallinna mänguväljakuid</a>
                                        </li>
                                    </ul>


                                    <p>
                                        <b>Tähelepanu!</b> Olenevalt toimingust tehakse hooldus-, heakorra- ja haljastustööde infosüsteemi
                                        registreeritud kasutaja kohta päringuid riigi registritest, näiteks rahvastikuregistrist,
                                        äriregistrist ja kinnistusraamatust.
                                        See võimaldab muuta infosüsteemi teenuste kasutamise mugavamaks.
                                    </p>
                                    <p>
                                        Isikuandmete töötlemisel lähtutakse Tallinna linna
                                        {' '}
                                        <a href="https://www.tallinn.ee/Andmekaitsetingimused" target="_blank" rel="noopener noreferrer">
                                            andmekaitsetingimustest
                                        </a>
                                    </p>
                                    <p>
                                        Infosüsteemi on kõige parem kasutada veebilehitsejate Google Chrome, Safari ja Mozilla Firefox uusimate versioonidega.
                                    </p>
                                    <p>
                                        Tehniliste probleemide korral võtke palun ühendust e-posti aadressil&nbsp;
                                        <a href="mailto:hhhis@tallinnlv.ee">hhhis@tallinnlv.ee</a>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const Home = connect(null, mapDispatchToProps)(ConnectedHome);
export default withRouter(withNamespaces('common')(Home));
